export default __webpack_public_path__ + "images/c19d5a4ffb4df8f6e1a3a6cbf097ec6b.png";